import { StatusBadge } from '@skylabs-digital/backoffice-kit';
import { Lock } from 'lucide-react';

/**
 * Lo que el CaC del producto declara (`managed_by = 'cac'`) no se edita acá:
 * la fuente de verdad es su `cac/stack.ts` y el próximo `yarn cac apply`
 * pisaría el cambio (docs/standards/skylabs-cac.md). El backoffice lo muestra
 * con este candado en lugar de los botones.
 */
export const CAC_MANAGED_TITLE = 'Managed by code (CaC): edit it in the product’s cac/stack.ts';

export function isManagedByCac(row: { managedBy?: string | null } | null | undefined): boolean {
  return row?.managedBy === 'cac';
}

export function ManagedByCacBadge() {
  return (
    <StatusBadge tone="info" dot={false} title={CAC_MANAGED_TITLE}>
      <Lock className="mr-1 inline size-3" aria-hidden="true" /> CaC
    </StatusBadge>
  );
}

export function ManagedByCacNotice({ what }: { what: string }) {
  return (
    <div
      role="note"
      className="flex items-start gap-2 rounded-md border border-border bg-muted/40 px-3 py-2 text-sm text-muted-foreground"
    >
      <Lock className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <span>
        This {what} is managed by code (CaC). Change it in the product’s{' '}
        <code className="font-mono text-xs">cac/stack.ts</code> and run{' '}
        <code className="font-mono text-xs">yarn cac apply</code>; edits made here would be
        overwritten by the next apply.
      </span>
    </div>
  );
}
